import React, { useState, useEffect } from 'react'
import {
    Dialog,
    Button,
    Typography,
    Select,
    MenuItem,
    FormControl,
    Box,
    Divider
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import { stateList } from '../../../containers/AppointmentBooking/constant'

const resolveStateCode = (state) => {
    if (!state) return ''
    const byCode = stateList.find((s) => s.state === state)
    if (byCode) return byCode.state
    const byLabel = stateList.find((s) => s.stateLabel.toLowerCase() === state.toLowerCase())
    if (byLabel) return byLabel.state
    return ''
}

const StateConfirmationModal = ({
    open,
    onClose,
    onConfirm,
    patientState,
}) => {

    const [selectedState, setSelectedState] = useState('')

    useEffect(() => {
        if (open) {
            setSelectedState(resolveStateCode(patientState))
        }
    }, [open, patientState])

    const handleContinue = () => {
        onConfirm(selectedState)
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: 600,
                    maxWidth: '95vw',
                    borderRadius: 2,
                    overflow: 'visible',
                }
            }}
        >
            {/* HEADER */}
            <Box
                sx={{
                    backgroundColor: '#5571C6',
                    px: 2.5,
                    py: 1.5,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography
                    sx={{
                        color: '#fff',
                        fontSize: '18px',
                        fontWeight: 600,
                    }}
                >
                    Where will you be located during your appointment?
                </Typography>

                <IconButton onClick={onClose} size="small">
                    <CloseIcon sx={{ color: '#fff' }} />
                </IconButton>
            </Box>

            {/* BODY */}
            <Box sx={{ px: 3, py: 2, overflow: 'visible' }}>

                {/* BLACK description text */}
                <Typography
                    sx={{
                        fontSize: '14px',
                        color: '#000',
                        mb: 1.5,
                    }}
                >
                    Telehealth rules require providers to know where patients are located during their visit.
                    Please select the state you will be in at the time of your appointment.
                </Typography>

                {/* Black divider */}
                <Divider sx={{ mb: 2, borderColor: '#00000020' }} />

                {/* Bold black label */}
                <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: 600,
                        mb: 1,
                        color: '#000'
                    }}
                >
                    State you will be in during your visit:
                </Typography>

                {/* Dropdown */}
                <FormControl fullWidth size="small">
                    <Select
                        value={selectedState}
                        displayEmpty
                        onChange={(e) => setSelectedState(e.target.value)}
                        MenuProps={{
                            disablePortal: true,
                            PaperProps: {
                                style: { maxHeight: 300 },
                            },
                        }}
                        sx={{
                            color: '#000',
                            '& .MuiSelect-select': {
                                color: '#000'
                            }
                        }}
                    >
                        <MenuItem value="">
                            <span style={{ color: '#000' }}>Select State</span>
                        </MenuItem>

                        {stateList.map((item) => (
                            <MenuItem
                                key={item.state}
                                value={item.state}
                                sx={{ color: '#000' }}
                            >
                                {item.stateLabel}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {/* Divider before buttons */}
                <Divider sx={{ mt: 3, mb: 2, borderColor: '#00000020' }} />

                {/* FOOTER BUTTONS */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: 2,
                    }}
                >
                    <Button
                        onClick={onClose}
                        variant="outlined"
                        sx={{
                            textTransform: 'none',
                            borderColor: '#5E7FDB',
                            color: '#5E7FDB',
                            px: 3
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        disabled={!selectedState}
                        onClick={handleContinue}
                        variant="contained"
                        sx={{
                            textTransform: 'none',
                            backgroundColor: '#5E7FDB',
                            px: 3,
                            '&:hover': { backgroundColor: '#4C67B2' }
                        }}
                    >
                        Continue
                    </Button>
                </Box>
            </Box>
        </Dialog>
    )
}

export default StateConfirmationModal